import { Transport } from './transport.interface';
import { Address } from './address.interface';

export interface Tours {
  readonly unfinished: Tour[];
  readonly upcoming: Tour[];
}

export interface Tour {
  readonly id: string;
  readonly externalId: string;
  readonly departure: string;
  readonly arrival: string;
  readonly amountOfLoadActions: number;
  readonly stops: TourStop[];
  readonly completed: boolean;
}

export interface TourStop {
  readonly id: string;
  readonly sequence: number;
  readonly type: TourStopType;
  readonly depot: string | null;
  readonly address: Address;
  readonly departure: string;
  readonly arrival: string;
  readonly status: TourStopStatus;
  readonly hasDocuments: boolean;
  readonly hasNotes: boolean;
  readonly hasC2cTransportActions: boolean;
  readonly actions: { unload: TourActionPoint[]; load: TourActionPoint[]; returnCargo: TourActionPoint[] };
}

export function getAllActions(tourStop: TourStop) {
  return [...tourStop.actions.load, ...tourStop.actions.unload, ...tourStop.actions.returnCargo];
}

export enum TourStopStatus {
  COMPLETED = 'COMPLETED',
  IN_PROGRESS = 'IN_PROGRESS',
  PLANNED = 'PLANNED'
}

export enum TourStopType {
  DEPOT = 'DEPOT',
  DELIVERY = 'DELIVERY',
  PICKUP = 'PICKUP'
}

export enum TourActionPointType {
  LOAD = 'LOAD',
  UNLOAD = 'UNLOAD',
  RETURN_CARGO = 'RETURN_CARGO'
}

export interface TourActionPoint {
  readonly id: string;
  readonly sequence: number;
  readonly transport: Transport;
  readonly showFuelReminder: boolean;
  readonly completed: boolean;
}
